import React from "react";
import PropTypes from "prop-types";
import { FormGroup, FormControl } from "react-bootstrap";
import "./TimePicker.css";

// clock format: HH:mm:ss

const getSubstringAsNumber = (str, startIndex, length) => {
	if(str === undefined || str === null) {
		return 999;
	}
	else {
		return Number(str.substr(startIndex, length)); 
	}
}

const getHoursOfString = (str) => { return getSubstringAsNumber(str, 0, 2); }
const getMinutesOfString = (str) => { return getSubstringAsNumber(str, 3, 2); }
const getSecondsOfString = (str) => { return getSubstringAsNumber(str, 6, 2); }

const addLeadingZeroForClockValue = (number) => {
	if(number < 10) {
		return "0" + number.toString();
	}
	else {
		return number.toString();
	}
}

const createClockTimeString = (hours, minutes, seconds) => {
	const hh = addLeadingZeroForClockValue(hours);
	const mm = addLeadingZeroForClockValue(minutes);
	const ss = addLeadingZeroForClockValue(seconds);
	return hh + ":" + mm + ":" + ss;
}

const getOptions = (startValue, endValue) => {
	let listItems = [];
	for(let i = startValue; i <= endValue; ++i) {
		listItems.push(<option key={i} value={i}>{addLeadingZeroForClockValue(i)}</option>);
	}
	return listItems;
}

export class TimePicker extends React.Component {

	constructor(props, context) {
		super(props, context);

		this.handleHoursChange = this.handleHoursChange.bind(this);
		this.handleMinutesChange = this.handleMinutesChange.bind(this);
		this.handleSecondsChange = this.handleSecondsChange.bind(this);
	}

	handleHoursChange(e) {
		this.props.onChange(
			createClockTimeString(
				e.target.value, 
				getMinutesOfString(this.props.value), 
				getSecondsOfString(this.props.value)
			)
		);
	}

	handleMinutesChange(e) {
		this.props.onChange(
			createClockTimeString(
				getHoursOfString(this.props.value), 
				e.target.value, 
				getSecondsOfString(this.props.value)
			)
		);
	}
	
	handleSecondsChange(e) { 
		this.props.onChange(
			createClockTimeString(
				getHoursOfString(this.props.value),
				getMinutesOfString(this.props.value), 
				e.target.value
			)
		);
	}

	getHoursMin() {
		return getHoursOfString(this.props.minTime);
	}

	getHoursMax() {
		return getHoursOfString(this.props.maxTime);
	}

	getMinutesMin() {
		const hoursSet = getHoursOfString(this.props.value);
		if(hoursSet === this.getHoursMin()) {
			return getMinutesOfString(this.props.minTime);
		}
		else {
			return 0;
		}
		
	}

	getMinutesMax() {
		const hoursSet = getHoursOfString(this.props.value);
		if(hoursSet === this.getHoursMax()) {
			return getMinutesOfString(this.props.maxTime);
		}
		else {
			return 59;
		}
		
	}

	getSecondsMin() {
		const hoursSet = getHoursOfString(this.props.value);
		const minutesSet = getMinutesOfString(this.props.value);
		if(
			(hoursSet === this.getHoursMin()) && 
			(minutesSet === this.getMinutesMin())
		) {
			return getSecondsOfString(this.props.minTime);
		}
		else {
			return 0;
		}
	}

	getSecondsMax() {
		const hoursSet = getHoursOfString(this.props.value);
		const minutesSet = getMinutesOfString(this.props.value);
		if(
			(hoursSet === this.getHoursMax()) && 
			(minutesSet === this.getMinutesMax())
		) {
			return getSecondsOfString(this.props.maxTime);
		}
		else {
			return 59;
		}
	}

	render() {
		return (
			<FormGroup controlId="formControlsSelect">
				<div className="Timepicker">
					<div id="HourMinuteSecondRow">
						<div id="HourField">
							<FormControl
								bsClass="ClockField"
								componentClass="select"
								onChange={this.handleHoursChange}
								value={getHoursOfString(this.props.value)}
							>
								{
									getOptions(
										this.getHoursMin(),
										this.getHoursMax()
									)
								}
							</FormControl>
						</div>
						<div id="Colon1">:</div>
						<div id="MinuteField">
							<FormControl
								bsClass="ClockField"
								componentClass="select"
								onChange={this.handleMinutesChange}
								value={getMinutesOfString(this.props.value)}
							>
								{
									getOptions(
										this.getMinutesMin(),
										this.getMinutesMax()
									)
								}
							</FormControl>
						</div>
						<div id="Colon2">:</div>
						<div id="SecondField">
							<FormControl
								bsClass="ClockField"
								componentClass="select"
								onChange={this.handleSecondsChange}
								value={getSecondsOfString(this.props.value)}
							>
								{
									getOptions(
										this.getSecondsMin(),
										this.getSecondsMax()
									)
								}
							</FormControl>
						</div>
					</div>
				</div>
		  	</FormGroup>
		);
	}
}

TimePicker.propTypes = {
	minTime: PropTypes.string.isRequired,
	maxTime: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired,
	disabled: PropTypes.bool
};